// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MAMode } from '../../IndicatorConstants';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iMAEx = 'iMAEx';
export class IMAEx extends iBuildInIndicator {
    constructor(period, maMethod, maShift, priceType, startWithBarIndex = undefined) {
        super(1);
        this.separateWindow = false;
        this.startWithBarIndex = 0;
        this.FPriceType = priceType;
        this.FMaMethod = maMethod;
        this.FMaPeriod = period;
        this.startWithBarIndex = startWithBarIndex !== null && startWithBarIndex !== void 0 ? startWithBarIndex : 0;
        this.FData.get(0).Shift = maShift;
    }
    get SeparateWindow() {
        return this.separateWindow;
    }
    get MAPeriod() {
        return this.FMaPeriod;
    }
    get MaMethod() {
        return this.FMaMethod;
    }
    get Name() {
        return iMAEx;
    }
    get Key() {
        return this.DefaultKey + this.MAPeriod + this.MaMethod + this.FPriceType;
    }
    OnQuote(ci, callBound, callFromRefresh = false) {
        if (this.FMaPeriod <= 0) {
            return;
        }
        switch (this.FMaMethod) {
            case MAMode.SMA:
                this.OnSMA();
                break;
            case MAMode.EMA:
                this.OnEMA();
                break;
            case MAMode.SMMA:
                this.OnSMMA();
                break;
            case MAMode.LWMA:
                this.OnLWMA();
                break;
        }
    }
    OnSMA() {
        if (!this.FParent) {
            return;
        }
        if (this.FCount >= this.FMaPeriod + this.startWithBarIndex) {
            let summa = 0; // Sum of prices
            for (let period = 0; period < this.FMaPeriod; period++) {
                summa += this.GetPrice(this.FPriceType, period); // Adding bar's price to the summa
            }
            // Setting the current value of the indicator
            this.SetValue(0, 0, summa / this.FMaPeriod);
        }
    }
    OnEMA() {
        // Checking, if current amount of bars
        // more, than period of moving average. If it is
        // then the calculation is possible
        if (!this.FParent) {
            return;
        }
        const price = this.GetPrice(this.FPriceType, 0);
        if (this.FCount > this.FMaPeriod + this.startWithBarIndex) {
            // Calculation of a coefficient
            const k = 2 / (this.FMaPeriod + 1);
            // Getting previous EMA
            const prevEMA = this._GetValue(0, 1);
            const s = prevEMA + k * (price - prevEMA);
            this.SetValue(0, 0, s);
        }
        else if (this.FCount === this.FMaPeriod + this.startWithBarIndex) {
            this.OnSMA();
        }
    }
    OnSMMA() {
        // Checking, if current amount of bars
        // more, than period of moving average. If it is
        // then the calculation is possible
        if (!this.FParent) {
            return;
        }
        if (this.FCount > this.FMaPeriod + this.startWithBarIndex) {
            const prevMa = this._GetValue(0, 1);
            // Setting the current value of the indicator
            this.SetValue(0, 0, (prevMa * (this.FMaPeriod - 1) + this.GetPrice(this.FPriceType, 0)) / this.FMaPeriod);
        }
        else if (this.FCount === this.FMaPeriod + this.startWithBarIndex) {
            this.OnSMA();
        }
    }
    OnLWMA() {
        // Checking, if current amount of bars
        // more, than period of moving average. If it is
        // then the calculation is possible
        if (!this.FParent) {
            return;
        }
        if (this.FCount >= this.FMaPeriod + this.startWithBarIndex) {
            let numerator = 0; // Numerator of the rate
            let denominator = 0; // Denominator of the rate
            for (let i = 0; i < this.FMaPeriod; i++) {
                const weight = this.FMaPeriod - i;
                numerator += weight * this.GetPrice(this.FPriceType, i);
                denominator += weight;
            }
            // Setting the current value of the indicator
            if (denominator !== 0) {
                this.SetValue(0, 0, numerator / denominator);
            }
        }
    }
}
